import { Box, Typography } from '@mui/material';
import Logo from '../assets/images/logo-1.png';

const Maintenance = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        backgroundColor: '#f8f9fb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 2,
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <Box>
        {/* LOGO */}
        <Box mb={3}>
          <img
            src={Logo}
            alt="Company Logo"
            style={{
              height: '60px',
              objectFit: 'contain',
            }}
          />
        </Box>

        {/* Heading */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 3,
            color: '#2c3345',
          }}
        >
          Site is Under Maintenance
        </Typography>

        {/* Setting Icon */}
        <Box sx={{ position: 'relative', mb: 3, display: 'inline-block' }}>
          <i
            className="bi bi-gear-fill"
            style={{
              fontSize: '70px',
              color: '#d6dce5',
            }}
          />
          <i
            className="bi bi-gear-fill"
            style={{
              fontSize: '30px',
              color: '#fbbf24',
              position: 'absolute',
              top: '-10px',
              right: '-30px',
            }}
          />
        </Box>

        {/* Message */}
        <Typography
          sx={{
            fontSize: '18px',
            color: '#6b7280',
            lineHeight: 1.6,
            maxWidth: '700px',
            margin: '0 auto',
          }}
        >
          Sorry for the inconvenience. <br />
          The site is currently unavailable due to <b>planned database maintenance</b>.<br />
          If you require assistance in the meantime, please contact us at{' '}
          <Typography component="span" sx={{ fontWeight: 600, color: '#2c3345' }}>
            helpdesk@autoind.com.au
          </Typography>
        </Typography>
      </Box>
    </Box>
  );
};

export default Maintenance;
